import React                       from 'react';
import PropTypes                   from 'prop-types';
import Translations                from '../../../utils/Translations';
import {getInitialTimer, getTimer} from '../TimerHelper';
import OfferIcon                   from '../SubComponents/OfferIcon';


class DailybonusTodayOfferHeadLine extends React.Component {

	constructor(props) {
		super(props);
		this.state          = {
			timer: getInitialTimer(),
		};
		this.addTimer       = this.addTimer.bind(this);
	}

	componentDidMount() {
		this.addTimer();
		this.timer = setInterval(
			() => { this.addTimer(); },
			1000
		);
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	addTimer() {
		this.setState({
			timer: getTimer(),
		});
	}

	render() {
		const {timer}   = this.state;
		let subHeadLine = '';
		if (this.props.purchased) {
			subHeadLine = Translations.get('renderHeadLine_' + this.props.offer);
		}

		return (
			this.props.mobile ?
				<div className="dailybonus__mobile--item__headline">
					<h3><OfferIcon offer={this.props.offer} purchased={this.props.purchased} />{Translations.get('renderHeadLine_TodayOffer')}</h3>
					{!this.props.purchased && <span className='dailybonus__mobile--item__headline-timer'> {timer.hour}:{timer.minutes}:{timer.seconds}</span>}
				</div> :
				<h3 className="dailybonus-today-item__headline">
					{Translations.get('renderHeadLine_TodayOffer')}{subHeadLine}
					{!this.props.purchased && <span className='dailybonus-today-item__headline-timer'> {timer.hour}:{timer.minutes}:{timer.seconds}</span>}
				</h3>
		);
	}
}

DailybonusTodayOfferHeadLine.propTypes = {
	purchased: PropTypes.bool,
	offer:     PropTypes.string,
	mobile:    PropTypes.bool,
};


export default DailybonusTodayOfferHeadLine;
